export default __webpack_public_path__ + "static/media/raven.1dff626c.png";